module.exports = __webpack_public_path__ + "./fonts/DMSans-Italic.263ef5.woff";